/**
 * Split a single CSV line into fields. Handles unquoted fields,
 * double-quoted fields (may contain commas), escaped double-quotes ("")
 * inside quoted fields, and a trailing comma (empty final field).
 */
export function splitCsvLine(line: string): string[] {
  const fields: string[] = [];
  let i = 0;

  while (i < line.length) {
    if (line[i] === '"') {
      let field = "";
      i++;
      while (i < line.length) {
        if (line[i] === '"') {
          if (line[i + 1] === '"') {
            field += '"';
            i += 2;
          } else {
            i++;
            break;
          }
        } else {
          field += line[i];
          i++;
        }
      }
      fields.push(field);
      if (i < line.length && line[i] === ",") i++;
    } else {
      const commaIdx = line.indexOf(",", i);
      if (commaIdx === -1) {
        fields.push(line.slice(i));
        break;
      } else {
        fields.push(line.slice(i, commaIdx));
        i = commaIdx + 1;
      }
    }
  }

  if (line.length > 0 && line[line.length - 1] === ",") {
    fields.push("");
  }

  return fields;
}
